import { render } from "./NewsSubscribeForm.vue?vue&type=template&id=4ebc7f3e"
import script from "./NewsSubscribeForm.vue?vue&type=script&lang=js"
export * from "./NewsSubscribeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__